import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { transformToNestObject } from 'react-hook-form';
// This helper method basically transforms yup validation errors into
// an error object that react-hook-form understands.
// It converts an array of errors into an object, keyed by path:
// ```
//  [{path,message,type}] => {[path] => {message, type}}
// ```
// By default it will return only a single error type per path (since we're
// mostly interested in showing one field error at a time and we can bail on
// other failed validations), but it can optionally return all the error types
// for every field path.
const parseErrorSchema = (error, validateAllFieldCriteria)=>Array.isArray(error.inner) && error.inner.length ? error.inner.reduce((previous, { path, message, type })=>{
        const previousTypes = previous[path] && previous[path].types || {};
        return _object_spread({}, previous, path ? {
            [path]: _object_spread({}, previous[path] || {
                message,
                type
            }, validateAllFieldCriteria ? {
                types: _object_spread_props(_object_spread({}, previousTypes), {
                    [type]: previousTypes[type] ? [
                        ...[].concat(previousTypes[type]),
                        message
                    ] : message
                })
            } : {})
        } : {});
    }, {}) : {
        [error.path]: {
            message: error.message,
            type: error.type
        }
    };
export const yupResolver = (schema, options = {
    abortEarly: false
})=>async (values, context, validateAllFieldCriteria = false)=>{
        try {
            if (options.context && process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead");
            }
            return {
                values: await schema.validate(values, _object_spread_props(_object_spread({}, options), {
                    context
                })),
                errors: {}
            };
        } catch (e) {
            const parsedErrors = parseErrorSchema(e, validateAllFieldCriteria);
            return {
                values: {},
                errors: validateAllFieldCriteria ? parsedErrors : transformToNestObject(parsedErrors)
            };
        }
    };
export default yupResolver;

//# sourceMappingURL=yupResolver.js.map